const navigateToGoSite = (redirectUrl) => {
  return `${process.env.REACT_APP_GO_LOGIN}?redirectUrl=${redirectUrl}&t=${localStorage.getItem('auth_token')}`
}

export default navigateToGoSite
